import { map } from 'rxjs/operators';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../shared/services/global.service';
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { CASH_ADVANCE_STATUS, CASH_ADVANCE_TYPE, INVOICE_STATUS, INVOICE_TYPES } from 'src/app/shared/conf/cash_advance';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FinanceService {

	public $dataObservable = new BehaviorSubject<any>(null);
	public $isOnBudgetDetail = new BehaviorSubject<boolean>(false);
	public $changeEditLine = new BehaviorSubject<any>(null);
	public $saveLine = new BehaviorSubject<any>(null);
	public $reloadAccounts = new BehaviorSubject<any>(false);
	

	dataObservable(): Observable<any> {
		return this.$dataObservable.asObservable();
	}
	updateDataObservable(data) {
		this.$dataObservable.next(data);
	}

	isOnBudgetDetail(): Observable<boolean> {
		return this.$isOnBudgetDetail.asObservable();
	}
	updateisOnBudgetDetail(data: boolean) {
		this.$isOnBudgetDetail.next(data);
	}

	changeEditLine(): Observable<any> {
		return this.$changeEditLine.asObservable();
	}
	updateChangeEditLine(data) {
		this.$changeEditLine.next(data);
	}

	saveLine(): Observable<any> {
		return this.$saveLine.asObservable();
	}
	updateSaveLine(data) {
		this.$saveLine.next(data);
	}

	reloadAccounts(): Observable<any> {
		return this.$reloadAccounts.asObservable();
	}
	updateReloadAccounts(data) {
		this.$reloadAccounts.next(data);
	} 


	/** Validates main access and cash advance status to add/edit invoice */
	hasAccessEditInvoice(cash_advance) {
		return (this._gS.validateAcces({ id: 47, type: 'write' }) || this._gS.validateAcces({ id: 31, type: 'write' }))
			&& this.canAddInvoice(cash_advance);
	}

	/** Shows Accounting or clearing of an invoice */
	showOtherFieldsInvoice(invoice) {
		return invoice &&
			(invoice.invoice_status_id == INVOICE_STATUS.Legalized ||
				invoice.invoice_status_id == INVOICE_STATUS.ReviewedFinances)
	}

	/** Validates if adding and invoice is available taking into consideration cash advance */
	canAddInvoice(cash_advance) {
		return (cash_advance.ca_ad_status_id != CASH_ADVANCE_STATUS.Rejected && cash_advance.ca_ad_status_id != CASH_ADVANCE_STATUS.Requested
			&& cash_advance.ca_ad_status_id != CASH_ADVANCE_STATUS.Legalized);
	}

	/** Validates if editing an invoice is available taking into consideration status and access */
	canEditInvoice(invoice) {
		if (!invoice) return false;
		return (invoice.invoice_type_id != INVOICE_TYPES.Refund || this._gS.validateAcces({ id: 47, type: 'write' }))
			&& invoice.invoice_status_id != INVOICE_STATUS.Rejected
			&& (this.productionCanEditInvoice(invoice) || this._gS.validateAcces({ id: 47, type: 'write' }))
	}

	/** These are the only statuses that production user (access 31) can edit an invoice */
	productionCanEditInvoice(invoice) {
		return invoice.invoice_status_id == INVOICE_STATUS.New
			|| invoice.invoice_status_id == INVOICE_STATUS.Submitted
	}

	importBudget(list, project_id) {
		let data = {
			session_id: this._gS.session_token,
			list: list,
			project_id: project_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/import_budget', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	loadBudget(file, project_id) {
		let url_service = this._gS.service_url + 'finance/load_budget'
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('file', file);
		formData.append('project_id', project_id);
		return this.http
			.post(url_service, formData)
			.pipe(map((response: Response) => response))
	}
	getForecastProjects() {
		return this.http.get(this._gS.service_url + 'finance/get_forecast_projects', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)

		})
	}
	legalizeInvoice(invoice_id, account_code_id) {
		let data = {
			session_id: this._gS.session_token,
			invoice_id: invoice_id,
			account_code_id: account_code_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/legalize_invoice', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	rejectInvoice(invoice_id) {
		let data = {
			session_id: this._gS.session_token,
			invoice_id: invoice_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/reject_invoice', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	approveInvoice(invoice_id, invoice_status_id = INVOICE_STATUS.Approved) {
		let data = {
			session_id: this._gS.session_token,
			invoice_id: invoice_id,
			invoice_status_id: invoice_status_id
		};
		return this.http.post(this._gS.service_url + 'finance/approved_invoice_id', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	reviewInvoice(invoice_id) {
		let data = {
			session_id: this._gS.session_token,
			invoice_id: invoice_id,
		};
		return this.http.post(this._gS.service_url + 'finance/reviewed_invoice', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	reverseInvoice(invoice_id) {
		let data = {
			session_id: this._gS.session_token,
			invoice_id: invoice_id,
		};
		return this.http.post(this._gS.service_url + 'finance/reverse_reject_invoice', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	approveAllInvoices(cash_advance_id, filtered_invoices_ids) {
		let data = {
			session_id: this._gS.session_token,
			cash_advance_id: cash_advance_id,
			filtered_invoices_ids: filtered_invoices_ids
		};
		return this.http.post(this._gS.service_url + 'finance/approved_invoice_multiple', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	submitCashAdvance(cash_advance_id, values) {
		let formData = new FormData();

		formData.append('session_id', this._gS.session_token);
		formData.append('cash_advance_id', cash_advance_id);
		// formData.append('file', values.file);

		return this.http.post(this._gS.service_url + 'finance/submit_cash_advance', formData).pipe(map((response: Response) => response))
	}

	addCommentInvoice(invoice_id, values) {
		let data = {
			session_id: this._gS.session_token,
			invoice_id: invoice_id,
			comment: values.comment
		};
		return this.http.post(this._gS.service_url + 'finance/create_comment_invoces', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	legalizeCashAdvance(cash_advance_id) {
		let data = {
			session_id: this._gS.session_token,
			cash_advance_id: cash_advance_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/legalize_cash_advance', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addInvoice(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values,
			comment: values.comment ? values.comment : undefined
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/add_invoice', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addInvoiceData(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			accounting_number: values.accounting_number,
			clearing: values.clearing,
			invoice_number: values.invoice_number

		};
		return this.http.post(this._gS.service_url + 'finance/add_data_invoces', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addInvoiceFile(invoice_id, file) {
		let formData = new FormData();

		formData.append('session_id', this._gS.session_token);
		formData.append('id', invoice_id);
		formData.append('file', file);

		return this.http.post(this._gS.service_url + 'finance/add_file_invoices', formData).pipe(map((response: Response) => response))
	}
	getInvoiceData(project_id = null) {
		return this.http.get(this._gS.service_url + 'finance/get_invoice_data', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('project_id', project_id)
		})
	}
	getVendorValidation(vendor_number = '', vendor_document = '', vendor_type_id = null) {
		let params = new HttpParams({
			fromObject: {
				'session_id': this._gS.session_token,
				'vendor_number': vendor_number,
				'vendor_document': vendor_document,
				'vendor_type_id': vendor_type_id
			}
		});
		return this.http.get(this._gS.service_url + 'finance/validate_vendor', {
			params: params
		}).pipe(map((response: any) => {
			return response.vendor;
		}))
	}
	getInvoiceDetail(invoice_id) {
		return this.http.get(this._gS.service_url + 'finance/get_invoice_detail', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('id', invoice_id)
		}).pipe(map((response: any) => {
			if (!response.history) return response;
			response.history.map(hs => {
				hs.type_history_eng = hs.type_history == 1 ? 'Status' : 'Edit';
				hs.type_history_esp = hs.type_history == 1 ? 'Estado' : 'Edición';
			})
			return response;
		}))
	}
	removeInvoiceComment(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/disabled_comment_invoces', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	reviewCash(cash_advance_id, status_action, approval_id, values) {
		let data = {
			session_id: this._gS.session_token,
			cash_advance_id: cash_advance_id,
			status_action: status_action,
			ca_ad_approval_id: approval_id,
			values: values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/approve_cash_advance', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	saveVendorDocument(vendor_id, file, document_id, vendor_document_id) {
		let url_service = this._gS.service_url + 'finance/save_vendor_document'
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('id', document_id)
		formData.append('vendor_document_id', vendor_document_id)
		formData.append('vendor_id', vendor_id)
		formData.append('file', file);
		return this.http
			.post(url_service, formData)
			.pipe(map((response: Response) => response))
	}
	saveVendor(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/save_vendor', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteCashApproval(approval_id) {
		let data = {
			session_id: this._gS.session_token,
			id: approval_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/delete_ca_ad_approvals', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addCashApproval(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/save_ca_ad_approvals', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getForecast(project_id, currency_id) {
		let data = {
			session_id: this._gS.getSeesion(),
			project_id: project_id,
			currency_id: currency_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/get_forecast', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	getProjects() {
		let data = {
			session_id: this._gS.getSeesion()
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'projects/list_projects', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addAccount(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/save_account_codes', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteAccountcode(account_id) {
		let data = {
			session_id: this._gS.session_token,
			id: account_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/delete_account', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getVendors(project_id?: string, order?, filters?: any, page?: number) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id ? project_id : null,
			filters: filters,
			page: page,
			order: order,
		};
		return this.http.post(this._gS.service_url + 'finance/get_vendors', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteTax(tax_id) {
		let data = {
			session_id: this._gS.session_token,
			id: tax_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/delete_tax', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteTaxOption(tax_option_id) {
		let data = {
			session_id: this._gS.session_token,
			id: tax_option_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/delete_tax_option', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addTax(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/add_tax', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addTaxOption(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/add_tax_option', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteVendorType(vendor_type_id) {
		let data = {
			session_id: this._gS.session_token,
			id: vendor_type_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/delete_vendor_type', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	deleteVendorDocument(vendor_document_id) {
		let data = {
			session_id: this._gS.session_token,
			id: vendor_document_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/delete_vendor_document', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	addVendorType(values) {
		let data = {
			session_id: this._gS.session_token,
			values: values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/add_vendor_type', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addVendorDocument(values) {
		// ven_doc_guide
		// vendor_type_id
		// ven_doc_name
		// ven_doc_description
		// mandatory

		let url_service = this._gS.service_url + 'finance/add_vendor_document'
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('id', values.id)
		formData.append('ven_doc_guide', values.ven_doc_guide)
		formData.append('vendor_type_id', values.vendor_type_id)
		formData.append('ven_doc_name', values.ven_doc_name)
		formData.append('ven_doc_description', values.ven_doc_description)
		formData.append('mandatory', values.mandatory)
		return this.http
			.post(url_service, formData)
			.pipe(map((response: Response) => response))
	}
	financeConfigData() {
		return this.http.get(this._gS.service_url + 'finance/finance_config_data', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
		})
	}
	cashRequestData(project_id = null) {
		let data = {
			project_id: project_id,
			session_id: this._gS.session_token
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/cash_request_data', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	filterCashAdvances(project_id?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id ? project_id : undefined
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/cash_advances_filter', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	CashAdvanceRequest(formData) {
		let data = {
			session_id: this._gS.session_token,
			values: formData
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/cash_advance_request', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}
	CashAdvanceEdit(formData) {
		let data = {
			session_id: this._gS.session_token,
			values: formData
		};
		return this.http.post(this._gS.service_url + 'finance/cash_advance_edit', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	CashAdvanceDelete(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/cash_advance_delete', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	cashAdvanceDeleteInvoice(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/delete_invoice', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	ListCashAdvances(project_id?: string, filters?: any, statuses_ids?, advance_type_ids?, order?, page?: number) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id ? project_id : undefined,
			statuses_ids: statuses_ids,
			advance_type_ids: advance_type_ids,
			filters: filters,
			date_from: filters.date_from,
			order: order,
			page: page,
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/list_cash_advances', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}
	getCashAdvanceDetail(cash_advance_id, project?) {
		let data = {
			session_id: this._gS.session_token,
			cash_advance_id: cash_advance_id,
			project_id: project ? project.id : undefined
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/get_cash_advance_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}
	ApproveCashAdvance(cash_advance_id, number) {
		let data = {
			session_id: this._gS.session_token,
			cash_advance_id: cash_advance_id,
			number: number
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/cash_advance_approve', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}

	setBudget(accounts) {
		const data = {
			session_id: this._gS.session_token,
			accounts,
		};
		const body = JSON.stringify(data);

		return this.http.post(this._gS.service_url + 'finance/save_budget', data, this._gS.httpOptions).pipe(
			map((response: Response) => response));
	}

	changeVendorStartus(values) {
		let data = {
			session_id: this._gS.session_token,
			values
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/change_vendor_status', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))

	}

	deleteVendor(vendor_id) {
		let data = {
			session_id: this._gS.session_token,
			id: vendor_id
		};
		var body = JSON.stringify(data)
		return this.http.post(this._gS.service_url + 'finance/delete_vendor', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getVendorDetail(vendor_id) {
		return this.http.get(this._gS.service_url + 'finance/get_vendor_detail', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('vendor_id', vendor_id)
		})
	}

	getListContracts(project_id?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id ? project_id : undefined
		};
		return this.http.post(this._gS.service_url + 'finance/list_contract', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getProjectWbs(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'finance/list_account_code', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createContract(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			project_id: values.project_id,
			budget_account_id: values.budget_account_id,
			job_name: values.job_name,
			job_description: values.job_description,
			vendor_id: values.vendor_id ? values.vendor_id : undefined,
			vendor_type_id: values.vendor_type_id,
			vendor_name: values.vendor_name,
			vendor_document: values.vendor_document,
			contract_number: values.contract_number,
			contract_type_id: values.contract_type_id,
			payment_type_id: values.payment_type_id,
			contract_sign_date: values.contract_sign_date,
			contract_start_date: values.contract_start_date,
			contract_end_date: values.contract_end_date,
			statements: values.statements,
			cost: values.cost,
			file_delete: values.file_delete
		};
		return this.http.post(this._gS.service_url + 'finance/create_contract', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	detailContract(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/detail_contract', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addContractFile(invoice_id, file) {
		let formData = new FormData();

		formData.append('session_id', this._gS.session_token);
		formData.append('id', invoice_id);
		formData.append('file', file);

		return this.http.post(this._gS.service_url + 'finance/add_file_contract', formData).pipe(map((response: Response) => response))
	}

	addContractComment(values, contract_id) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			comment: values.comment,
			contract_id: contract_id
		};
		return this.http.post(this._gS.service_url + 'finance/add_comment_contract', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteContract(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'finance/delete_contract', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteCommentContract(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'finance/delete_comment_contract', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getFinanceServices(project_id?: string, order?, filters?: any, page?: number, isFinances: boolean = false) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id ? project_id : null,
			filters: filters,
			page: page,
			service_statuses: isFinances,
			order: order,
		};
		return this.http.post(this._gS.service_url + 'finance/get_services', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getServiceFilter(project_id?) {
		let params = new HttpParams({
			fromObject: {
				'session_id': this._gS.session_token
			}
		});
		if (project_id) {
			params = params.append('project_id', project_id);
		}
		return this.http.get(this._gS.service_url + 'finance/get_service_filter', {
			params: params
		})
	}

	deleteFileService(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'finance/delete_file_service', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getFilesServices(call_sheet_special_id) {
		return this.http.get(this._gS.service_url + 'finance/get_service_files', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('call_sheet_special_id', call_sheet_special_id)
		})
	}

	addServicePurchaseOrder(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			po: values.purchase_order,
		};
		return this.http.post(this._gS.service_url + 'finance/add_service_po', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addServiceInvoice(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values.id,
			invoice: values.invoice,
		};
		return this.http.post(this._gS.service_url + 'finance/add_service_invovice', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	changeServiceStatus(service_id, new_status_id) {
		let data = {
			session_id: this._gS.session_token,
			id: service_id,
			status_id: new_status_id,
		};
		return this.http.post(this._gS.service_url + 'finance/change_service_status', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	changeCateringStatus(catering_id, new_status_id) {
		let data = {
			session_id: this._gS.session_token,
			id: catering_id,
			status_id: new_status_id,
		};
		return this.http.post(this._gS.service_url + 'finance/change_catering_status', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	addDataCatering(id, value, type_id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			po: type_id == 1 ? value : undefined,
			invoice: type_id == 2 ? value : undefined,
			type_id: type_id,
		};
		return this.http.post(this._gS.service_url + 'finance/add_data_catering', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getCateringDetail(id, project_id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			project_id: project_id
		};
		return this.http.post(this._gS.service_url + 'finance/catering_detail', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteFileCatering(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'shooting_schedule/delete_file_catering', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getFinanceCaterings(project_id?: string, order?, filters?: any, page?: number, isFinances: boolean = false) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id ? project_id : null,
			filters: filters,
			page: page,
			service_statuses: isFinances,
			order: order,
		};
		return this.http.post(this._gS.service_url + 'finance/list_catering_call', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	saveSupportCashAdvance(cash_advance_id, file) {
		let url_service = this._gS.service_url + 'finance/save_cash_advance_file'
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('cash_advance_id', cash_advance_id)
		formData.append('file', file);
		return this.http
			.post(url_service, formData)
			.pipe(map((response: Response) => response))
	}

	deleteCashAdvanceSupport(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/cash_advance_delete_file', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteInvoiceFile(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/invoice_delete_file', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	updateVendorsList(data, project_id) {
		let url_service = this._gS.service_url + 'excel/create_vendor'
		let formData = new FormData();
		formData.append('project_id', project_id);
		formData.append('session_id', this._gS.session_token);
		formData.append('file', data.file);
		formData.append('production_center_id', data.production_center_id);
		return this.http
			.post(url_service, formData)
			.pipe(map((response: Response) => response))
	}

	getInvoiceHistory(invoice_id) {
		return this.http.get(this._gS.service_url + 'finance/get_invoice_history', {
			params: new HttpParams()
				.set('session_id', this._gS.session_token)
				.set('invoice_id', invoice_id)
		}).pipe(map((response: any) => {
			if (!response.history) return response;
			response.history.map(hs => {
				hs.type_history_eng = hs.type_history == 1 ? 'Status' : 'Edit';
				hs.type_history_esp = hs.type_history == 1 ? 'Estado' : 'Edición';
			})
			return response;
		}))
	}

	getServiceHistory(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/get_service_history', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getCateringHistory(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/get_catering_history', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	InActivateVendor(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id
		};
		return this.http.post(this._gS.service_url + 'finance/change_status_vendor', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetAccount(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			project_id: projectId,
			budget_account_group_id: values.budget_account_group_id,
			account_number: values.account_number,
			description: values.description
		};
		return this.http.post(this._gS.service_url + 'budget/createBudgetAccount', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetSubAccount(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			project_id: projectId,
			sub_account_number: values.account_number,
			description: values.description,
			budget_account_id: values.budget_account_id
		};
		return this.http.post(this._gS.service_url + 'budget/createBudgetSubAccount', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetGroupAccount(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			project_id: projectId,
			name: values.description,
			budget_sub_account_id: values.budget_account_id,
			parent_id: values.parent_id,
			extra_rows: values.array_extra_rows
		};
		return this.http.post(this._gS.service_url + 'budget/createItemGroup', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createProductionCountry(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			project_id: projectId,
			abbreviation: values.abbreviation,
			country: values.country,
			exchange: values.exchange
		};
		return this.http.post(this._gS.service_url + 'budget/createProductionCountry', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetGroup(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			project_id: projectId,
			abbreviation: values.abbreviation,
			name: values.name,
		};
		return this.http.post(this._gS.service_url + 'budget/createGroup', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetUnit(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			name: values.name,
		};
		return this.http.post(this._gS.service_url + 'budget/createUnit', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetTemplate(values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			name: values.name,
		};
		return this.http.post(this._gS.service_url + 'budget/createBudgetTemplate', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createGlobalParam(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			project_id: projectId,
			abbreviation: values.abbreviation,
			name: values.name,
			quantity: values.quantity,
			budget_unit_id: values.budget_unit_id
		};
		return this.http.post(this._gS.service_url + 'budget/createGlobal', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteProductionCountry(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'budget/removeProductionCountry', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteParameterGlobal(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'budget/removeGlobal', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBudgetGroup(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'budget/removeGroup', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBudgetUnit(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'budget/removeUnit', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getBudgetMasterData(projectId?, productionCountryId?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			production_country_id: productionCountryId
		};
		return this.http.post(this._gS.service_url + 'budget/getMasterAccounts', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getBudgetSubAccounts(accountId, projectId, productionCountryId?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			account_id: accountId,
			production_country_id: productionCountryId
		};
		return this.http.post(this._gS.service_url + 'budget/getMasterSubAccounts', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	getBudgetDetailAccounts(subAccountId, projectId, budget_groups, budget_account_id, productionCountryId?) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			sub_account_id: subAccountId,
			group_ids: budget_groups,
			account_id: budget_account_id,
			production_country_id: productionCountryId
		};
		return this.http.post(this._gS.service_url + 'budget/getMasterItems', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetDetail(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			id: values?.id,
			project_id: projectId,
			budget_number: values.budget_number,
			budget_sub_account_id: values.budget_account_id,
			description: values.description,
			budget_global_id: values.budget_global_id,
			amount: values.amount,
			budget_unit_id: values.budget_unit_id,
			multiplier: values.multiplier ? values.multiplier : 1,
			multiplier_x4: values.multiplier_x4,
			rate: values.rate,
			budget_production_country_id: values.budget_production_country_id,
			budget_groups: values.budget_groups,
			extra_rows: values.array_extra_rows,
			budget_item_group_id: values.budget_item_group_id,
			budget_assigned_project_id: values.budget_assigned_project_id,
			budget_type_id: values.budget_type_id
		};
		return this.http.post(this._gS.service_url + 'budget/createBudget', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBudgetAccount(id, project_id, budget_type_id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			project_id: project_id,
			budget_type_id: budget_type_id
		};
		return this.http.post(this._gS.service_url + 'budget/removeBudgetAccount', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBudgetSubAccount(id, projectId, budget_type_id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
			project_id: projectId,
			budget_type_id: budget_type_id
		};
		return this.http.post(this._gS.service_url + 'budget/removeBudgetSubAccount', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBudgetDetailAccount(id) {
		let data = {
			session_id: this._gS.session_token,
			id: id,
		};
		return this.http.post(this._gS.service_url + 'budget/removeBudget', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	deleteBudgetDetailGroup(id) {
		let data = {
			session_id: this._gS.session_token,
			item_group_id: id,
		};
		return this.http.post(this._gS.service_url + 'budget/removeItemGroup', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetNewVersion(project_id) {
		let data = {
			session_id: this._gS.session_token,
			project_id: project_id,
		};
		return this.http.post(this._gS.service_url + 'budget/newBudgetVersion', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetField(values, projectId?) {
		let data = {
			session_id: this._gS.session_token,
			row_title: values.row_title,
			is_text: values.type == 1 ? true : false,
			project_id: projectId
		};
		return this.http.post(this._gS.service_url + 'budget/newRowBudgetAccount', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	uploadBudgetByFile(project_id, values, url) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		formData.append('file', values.file);
		formData.append('url', url);
		formData.append('project_id', project_id);
		formData.append('budget_type_id', values.budget_type_id)
		return this.http.post(this._gS.service_url + 'workers/readMovieMagic', formData).pipe(
			map((response: Response) => response))
	}

	saveBudgetProject(projectId, values) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			production_center_id: values.production_center_id,
			project_category_id: values.project_category_id,
			pre_production_weeks: values.pre_production_weeks,
			production_weeks: values.production_weeks,
			post_production_weeks: values.post_production_weeks,
			wrap_weeks: values.wrap_weeks,
			chapters: values.chapters,
			units: values.units
		};
		return this.http.post(this._gS.service_url + 'budget/saveBudgetProject', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	createBudgetProject(projectId, url) {
		let data = {
			session_id: this._gS.session_token,
			project_id: projectId,
			url: url
		};
		return this.http.post(this._gS.service_url + 'workers/duplicateMasterBudget', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	saveFileBudgetAccount(projectId, values) {
		let formData = new FormData();
		formData.append('session_id', this._gS.session_token);
		Object.keys(values).map((key, index) => {
            if (key != 'extra_rows') {
                if(values[key]) formData.append(key, values[key]);
            } else {
                values[key]?.map((file, i) => {
                    formData.append(`extra_rows[${i}]project_id`, projectId || '');
                    formData.append(`extra_rows[${i}]response`, file?.response);
					if (values.is_group) formData.append(`extra_rows[${i}]budget_item_group_id`, file?.budget_item_group_id);
					else formData.append(`extra_rows[${i}]budget_item_id`, file?.budget_item_id);
                });
            }
        });

		return this.http
			.post(this._gS.service_url + 'budget/uploadRowresponse', formData)
			.pipe(map((response: Response) => response))
	}

	changeMultipleStatusInvoice(selectedIds, status) {
		let data = {
			session_id: this._gS.session_token,
			invoice_ids: selectedIds,
			invoice_status_id: status,
		};
		return this.http.post(this._gS.service_url + 'finance/multiple_status_changes_on_invoices', data, this._gS.httpOptions).pipe(
			map((response: Response) => response))
	}

	constructor(private _cS: CookieService, private http: HttpClient, public _gS: GlobalService) { }
}
